import React from 'react';
import logo from '../../assets/logo.png';
import { Logo, GreetingWrapper } from './EnrollmentFlow.styles';

// Same logo block and salaam greeting the sign-in page shows.
export default function EnrollmentBrand() {
  return (
    <>
      <Logo>
        <img src={logo} alt="Faith Insight Logo" />
        <h1>Faith Insight</h1>
        <p>Learning Portal</p>
      </Logo>
      <GreetingWrapper>
        <span className="arabic-text">السلام عليكم</span>
      </GreetingWrapper>
    </>
  );
}
